import imgix from 'imgix.js';

export default class Imgix {
    constructor() {
        if (imgix.instance) {
            return imgix.instance;
        }
        imgix.instance = this;

        this.registeredEvents = new Set();
        this.init();
    }

    init = () => {
        this.imageSelection(document).forEach((img) => {
            this.applyImgixSrcSet(img);
        });

        this.imageSelection(document, '.imgix-bg').forEach((el) => {
            this.applyBackgroundImage(el);
        });

        this.registerEvents(['revealOffcanvas', 'ajaxModalHasLoaded']);
    }

    applyImgixSrcSet = (img) => {
        const imagePath = img.dataset.src;
        const ixParams = JSON.parse(img.getAttribute("ix-params") || '{"fit":"crop", "crop":"faces,edges"}');

        // Build the query string
        const paramsString = new URLSearchParams(ixParams).toString(); // focal point
        const finalUrl = `${imagePath}${imagePath.includes('?') ? '&' : '?'}${paramsString}`;

        // Define widths for the srcset
        const aspectRatio = img.height / img.width
        const widths = [360, 420, 768, 900, 1024, 1280, 1440, 1600, 2000]; // srcset sizes to be generated
        const percentWidth = img.width / window.innerWidth;

        const dimensions = (width) => {
            let imgWidth = Math.ceil(width * percentWidth)
            let value = `&w=${imgWidth}`
            if(!img.classList.contains('img-fit')) {
                value += `&h=${Math.round(imgWidth * aspectRatio)}`
            }
            return value + "&q=70"
        }

        // Create the srcset and fallback src
        img.srcset = widths.map(width => `${finalUrl}${dimensions(width)} ${width}w`).join(', ');
        img.src = `${finalUrl}&q=70`; // Fallback src / noscript src
        img.sizes = "(max-width: 800px) 100vw, 2000px";
        img.loading = img.dataset.load; // Lazy / Eager

        // Store current values
        img.dataset.width = img.width;
        img.dataset.height = img.height;

        // Add loaded class on load
        img.onload = () => img.classList.add('has-loaded');
    }

    applyBackgroundImage = (el) => {
        const imagePath = el.dataset.src;
        const backgroundImageUrl = `${imagePath}&fit=clip&q=75`;

        // Apply as a background image
        el.style.backgroundImage = `url(${backgroundImageUrl})`;
    }

    imageSelection = (scope, selector = 'img.imgix-fluid') => {
        return Array.from(scope.querySelectorAll(selector)).filter(img => {

            let visible = img.offsetParent !== null;
            let unloaded = !img.classList.contains('has-loaded');
            let newsize = img.dataset.width != img.width || img.dataset.height != img.height;

            return visible && (unloaded || newsize); // Only process visible/unloaded images or re-sized images
        });
    }

    registerEvents = (events) => {
        events.forEach((event) => {
            if (!this.registeredEvents.has(event)) {
                document.addEventListener(event, () => this.handleEvent());
                this.registeredEvents.add(event);
            }
        });
    }

    handleEvent = (scope = document) => {
        this.imageSelection(scope).forEach((img) => {
            this.applyImgixSrcSet(img);
        });

        this.imageSelection(scope, '.imgix-bg').forEach((el) => {
            this.applyBackgroundImage(el);
        });
    }

    process = (el) => {
        if(el.classList.contains('imgix-fluid')) {
            this.applyImgixSrcSet(el);
        } else {
            this.handleEvent(el);
        }
    }
}

export const ixPolyfill = () => {
    window.addEventListener('load', () => {
        window.imgix = {
            fluid: () => {
                return false
            }
        }
    });

    // Catch all jQuery 'trigger' events and dispatch a native event
    (function($) {
        // Store the original jQuery trigger method
        const originalTrigger = $.fn.trigger;

        // Override the jQuery trigger method
        $.fn.trigger = function(eventType, extraParameters) {
            // Call the original trigger method first
            const result = originalTrigger.apply(this, arguments);

            // Ensure eventType is a string (in case it's an event object)
            const eventName = typeof eventType === "string" ? eventType : eventType.type;

            // Dispatch a native event
            this.each(function() {
                this.dispatchEvent(new CustomEvent(eventName, {
                    bubbles: true,
                    detail: extraParameters
                }));
            });

            return result; // Maintain jQuery chaining
        };
    })(jQuery);
}